import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules
import { TranslationModule } from '../../../translation/translation.module';

// Components
import { IntlPhoneComponent } from './components/intl-phone.component';

// Services
import { CountryService } from './services/country.service';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslationModule,
    ReactiveFormsModule
  ],
  declarations: [
    IntlPhoneComponent
  ],
  exports: [
    IntlPhoneComponent
  ],
  providers: [
    CountryService
  ]
})
export class InternationalPhoneModule {}



// WEBPACK FOOTER //
// ./src/app/shared/components/intl-phone/intl-phone.module.ts